/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PccPatientAddress } from './PccPatientAddress';
import {
    PccPatientAddressFromJSON,
    PccPatientAddressFromJSONTyped,
    PccPatientAddressToJSON,
    PccPatientAddressToJSONTyped,
} from './PccPatientAddress';

/**
 * 
 * @export
 * @interface PatchPccDemographicsRequest
 */
export interface PatchPccDemographicsRequest {
    /**
     * 
     */
    home_phone?: string;
    /**
     * 
     */
    cell_phone?: string;
    /**
     * 
     */
    language?: string;
    /**
     * 
     */
    marital_status?: string;
    /**
     * 
     */
    race?: string;
    /**
     * 
     */
    prefix?: string;
    /**
     * 
     */
    suffix?: string;
    /**
     * 
     */
    previous_address?: PccPatientAddress;
}

/**
 * Check if a given object implements the PatchPccDemographicsRequest interface.
 */
export function instanceOfPatchPccDemographicsRequest(value: object): value is PatchPccDemographicsRequest {
    return true;
}

export function PatchPccDemographicsRequestFromJSON(json: any): PatchPccDemographicsRequest {
    return PatchPccDemographicsRequestFromJSONTyped(json, false);
}

export function PatchPccDemographicsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchPccDemographicsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'home_phone': json['home_phone'] == null ? undefined : json['home_phone'],
        'cell_phone': json['cell_phone'] == null ? undefined : json['cell_phone'],
        'language': json['language'] == null ? undefined : json['language'],
        'marital_status': json['marital_status'] == null ? undefined : json['marital_status'],
        'race': json['race'] == null ? undefined : json['race'],
        'prefix': json['prefix'] == null ? undefined : json['prefix'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'previous_address': json['previous_address'] == null ? undefined : PccPatientAddressFromJSON(json['previous_address']),
    };
}

export function PatchPccDemographicsRequestToJSON(json: any): PatchPccDemographicsRequest {
    return PatchPccDemographicsRequestToJSONTyped(json, false);
}

export function PatchPccDemographicsRequestToJSONTyped(value?: PatchPccDemographicsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'home_phone': value['home_phone'],
        'cell_phone': value['cell_phone'],
        'language': value['language'],
        'marital_status': value['marital_status'],
        'race': value['race'],
        'prefix': value['prefix'],
        'suffix': value['suffix'],
        'previous_address': PccPatientAddressToJSON(value['previous_address']),
    };
}

